import { Box, SxProps } from '@mui/material';
import { FC } from 'react';

interface Props {
  children?: React.ReactNode;
  sx?: SxProps;
}

export const CabinetWrapper: FC<Props> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        borderRadius: '16px',
        p: 3,
        backgroundColor: '#fff',
        flex: 1,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
